import { TFunction } from 'i18next';
import {
  BrandName,
  SupportedCountryCode
} from '@seek/je-shared-data/lib/types/brand';
import videoQuestionOfJoraAu from '@seek/jora-matchbox/video-screening-questions-jora-au.json';
import videoQuestionOfJoraGb from '@seek/jora-matchbox/video-screening-questions-jora-gb.json';
import videoQuestionOfJoraHk from '@seek/jora-matchbox/video-screening-questions-jora-hk.json';
import videoQuestionOfJoraId from '@seek/jora-matchbox/video-screening-questions-jora-id.json';
import videoQuestionOfJoraMy from '@seek/jora-matchbox/video-screening-questions-jora-my.json';
import videoQuestionOfJoraNz from '@seek/jora-matchbox/video-screening-questions-jora-nz.json';
import videoQuestionOfJoraPh from '@seek/jora-matchbox/video-screening-questions-jora-ph.json';
import videoQuestionOfJoraTh from '@seek/jora-matchbox/video-screening-questions-jora-th.json';
import videoQuestionOfJseId from '@seek/jora-matchbox/video-screening-questions-jse-id.json';
import videoQuestionOfJseSg from '@seek/jora-matchbox/video-screening-questions-jse-sg.json';

const mapVideoScreeningQuestionsToMarket = {
  jora_au: videoQuestionOfJoraAu,
  jora_gb: videoQuestionOfJoraGb,
  jora_hk: videoQuestionOfJoraHk,
  jora_id: videoQuestionOfJoraId,
  jora_my: videoQuestionOfJoraMy,
  jora_nz: videoQuestionOfJoraNz,
  jora_ph: videoQuestionOfJoraPh,
  jora_th: videoQuestionOfJoraTh,
  jobstreetExpress_id: videoQuestionOfJseId,
  jobstreetExpress_sg: videoQuestionOfJseSg
};

type OptionsParams = {
  t: TFunction;
  brand: BrandName;
  countryCode: SupportedCountryCode;
  params: Record<string, string>;
};

export const CUSTOM_VIDEO_QUESTION_FIELD = 'customquestion';

export const options = ({
  t,
  brand,
  countryCode,
  params
}: OptionsParams): {
  label: string;
  key: string;
}[] => {
  const marketKey =
    `${brand}_${countryCode}` as keyof typeof mapVideoScreeningQuestionsToMarket;
  const videoQuestions = mapVideoScreeningQuestionsToMarket[marketKey];

  if (!videoQuestions) {
    throw new Error(`No video questions found for market ${marketKey}`);
  }

  const customQuestion = videoQuestions.find(
    (item) => item.code === CUSTOM_VIDEO_QUESTION_FIELD
  );

  const questions = videoQuestions
    .filter((item) => item.code !== CUSTOM_VIDEO_QUESTION_FIELD)
    .map((item) => ({
      label: t(item.question, params),
      value: item.code,
      key: item.code
    }));

  if (customQuestion) {
    questions.push({
      label: t(customQuestion.question, params),
      value: customQuestion.code,
      key: customQuestion.code
    });
  }

  return questions;
};
